import { useQuery } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  handleHTTPError,
  isHTTPError,
} from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export const useQueryMasterLatestBatchJobStatus = (
  masterUuid: string,
  showErrorSnackbar: (message: string) => void,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: queryKeys.masterLatestBatchJobStatus(masterUuid),
    queryFn: async () => {
      try {
        return await baseClient
          .getApi(MasterApi)
          .getMasterLatestBatchJobStatus({ masterUuid })
          .catch(handleHTTPError)
      } catch (error) {
        if (isHTTPError(error) && error.status !== 404) {
          showErrorSnackbar('予期せぬエラーが発生しました')
          return null
        }
        throw error
      }
    },
    retry: false,
    enabled,
    staleTime: 0,
  })
}
